import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { awsCognito } from '../config';

const CognitoPool = new CognitoUserPool(awsCognito);

export default CognitoPool;
